import { CommonModule } from '@angular/common';
import { NgModule } from '@angular/core';
import { CoreUiModule } from '../../core-ui/core-ui.module';
import { BulletBoxComponent } from './BulletBox.component';

@NgModule({
    imports: [
        CommonModule,
        CoreUiModule // OldIconModule (needed if this goes in CoreUi)
    ],
    declarations: [BulletBoxComponent],
    exports: [BulletBoxComponent],
    providers: []
})
export class BulletBoxModule {}
